module.exports = __webpack_public_path__ + "static/media/choithramsSafolaS.15b44b8a.png";